import PracticeAreasContent from './PracticeAreasContent';

export default PracticeAreasContent;
